module.exports = __webpack_public_path__ + "img/icon-skip-start-inactive.e5b84414.svg";